export const getters = {
  getLayers: state => {
    return state.layers
  },
  getDates: state => {
    return state.dates
  },
  getSelectedRange: state => {
    return state.selectedRange
  }
}
